import { PostgrestClient } from "@supabase/postgrest-js";

const REST_URL = "https://program-api-rest.universa.vip";
const postgrest = new PostgrestClient(REST_URL);

export default postgrest;
